/**
 * execSummaryOverride — short-lived shield around meta.execSummary so
 * a stale /meta refetch (60-second auto-poll, or KV's per-region read
 * cache returning yesterday's value) can't briefly revert the summary
 * the user just saved.
 *
 * Same shape as actionItemOverrides.js: write the authoritative value
 * after a successful save; reads prefer the override during the TTL.
 *
 * Why exec summary specifically: useMetaData runs `refetchInterval:
 * 60_000`, and Cloudflare KV's edge read cache can serve stale for up
 * to ~60s after a write. Without a shield, the next auto-refetch can
 * land mid-window and overwrite the cache with the pre-save state,
 * making it look like Save did nothing.
 *
 * Plain module-level state, identical pattern to actionItemOverrides.
 */

const OVERRIDE_TTL_MS = 15_000

let override = null // { value, at } | null

export function rememberExecSummary(value) {
  override = { value, at: Date.now() }
  setTimeout(() => {
    if (override && Date.now() - override.at >= OVERRIDE_TTL_MS) {
      override = null
    }
  }, OVERRIDE_TTL_MS + 100)
}

export function getExecSummaryOverride() {
  if (!override) return undefined
  if (
    !Number.isFinite(override.at) ||
    Date.now() - override.at >= OVERRIDE_TTL_MS
  ) {
    override = null
    return undefined
  }
  return override.value
}

export function clearExecSummaryOverride() {
  override = null
}
